export default __webpack_public_path__ + "static/media/nodejs.8629b14e.svg";